













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IconExit from '../assets/icon-exit.svg';

@Component({
	components: {
		IconExit
	}
})
export default class Overlay extends Vue {
	@Prop({default: false})
	show!: boolean;

	mounted() {
		this.$emit('update:show', true);
	}

	close() {
		this.$emit('update:show', false);
	}

	@Watch('show')
	onShowChange() {
		if(!this.show) {
			setTimeout(() => {
				this.$emit('close');
			}, 100);
		}
	}
}
